import { Spinner } from "@dd/ui";
import { RondaLogo } from "./ronda-logo.tsx";

/**
 * Estado de arranque: todavía no existe un shell en el que apoyar skeletons.
 * Mantenerlo separado de los placeholders internos evita mostrar una maqueta
 * de dashboard antes de saber qué layout corresponde a la sesión.
 */
export function FullScreenLoader() {
  return (
    <div
      className="grid min-h-dvh place-items-center bg-background px-6"
      aria-label="Cargando Ronda"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-5 text-center">
        <RondaLogo className="h-9 w-[6.95rem]" />
        <div className="flex items-center gap-2.5 text-sm text-muted-foreground">
          <Spinner
            label=""
            className="text-primary [&>span]:h-5 [&>span]:w-5"
          />
          <span>Preparando tu espacio…</span>
        </div>
      </div>
    </div>
  );
}
